module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projekter topspacing"
  }, [_c('div', {
    staticClass: "grid-x content"
  }, [_c('div', {
    staticClass: "small-8 cell"
  }, [_vm._m(0), _vm._v(" "), _c('datepicker', {
    attrs: {
      "id": "datepicker",
      "name": "Datepicker",
      "language": "da",
      "placeholder": "I dag"
    },
    on: {
      "selected": _vm.getSelectedDate
    },
    model: {
      value: (_vm.state.date),
      callback: function($$v) {
        _vm.$set(_vm.state, "date", $$v)
      },
      expression: "state.date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "small-4 cell"
  }, [_c('div', {
    staticClass: "user special-text text-right",
    on: {
      "click": _vm.showUsers
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.selectedUser.navn) + " "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("keyboard_arrow_down")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUserList),
      expression: "showUserList"
    }],
    staticClass: "user-list"
  }, [_c('ul', _vm._l((_vm.users), function(user) {
    return _c('li', {
      key: user.id,
      on: {
        "click": function($event) {
          return _vm.selectUser(user)
        }
      }
    }, [_vm._v("\n              " + _vm._s(user.navn) + "\n            ")])
  }), 0)])])])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredResult.length > 0),
      expression: "filteredResult.length > 0"
    }],
    staticClass: "list content",
    class: {
      'hide-list': _vm.createNew
    }
  }, _vm._l((_vm.projectView), function(project, index) {
    return _c('li', {
      key: project.id,
      on: {
        "click": function($event) {
          return _vm.gotoProject(project)
        }
      }
    }, [_c('div', {
      staticClass: "grid-x"
    }, [_c('div', {
      staticClass: "small-1 cell"
    }, [_c('div', {
      staticClass: "status dark-color",
      class: _vm.classObject(project)
    }, [(index < 9) ? _c('span', [_vm._v("0")]) : _vm._e(), _vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "small-6 cell"
    }, [_c('span', [_vm._v(_vm._s(project.bookingTypeNavn))]), _c('br'), _vm._v(" "), (!project.adresse.etage && !project.adresse.doer) ? _c('p', {
      staticClass: "small-text"
    }, [_vm._v(_vm._s(_vm._f("shorten")(project.adresse.vejnavn + ' ' + project.adresse.husnummer + ', ' + project.adresse.postnummer + ' ' + project.adresse.by)))]) : _vm._e(), _vm._v(" "), (project.adresse.etage && !project.adresse.doer) ? _c('p', {
      staticClass: "small-text"
    }, [_vm._v(_vm._s(_vm._f("shorten")(project.adresse.vejnavn + ' ' + project.adresse.husnummer + '. ' + project.adresse.etage + ', ' + project.adresse.postnummer + ' ' + project.adresse.by)))]) : _vm._e(), _vm._v(" "), (!project.adresse.etage && project.adresse.doer) ? _c('p', {
      staticClass: "small-text"
    }, [_vm._v(_vm._s(_vm._f("shorten")(project.adresse.vejnavn + ' ' + project.adresse.husnummer + '. ' + project.adresse.doer + ', ' + project.adresse.postnummer + ' ' + project.adresse.by)))]) : _vm._e(), _vm._v(" "), (project.adresse.etage && project.adresse.doer) ? _c('p', {
      staticClass: "small-text"
    }, [_vm._v(_vm._s(_vm._f("shorten")(project.adresse.vejnavn + ' ' + project.adresse.husnummer + '. ' + project.adresse.etage + ' - ' + project.adresse.doer + ', ' + project.adresse.postnummer + ' ' + project.adresse.by)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "small-4 cell padding-text"
    }, [_vm._v("\n          " + _vm._s(_vm._f("moment")(project.fratid)) + " - " + _vm._s(_vm._f("moment")(project.tiltid)) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "small-1 cell icon-center"
    }, [(project.bemaerkning !== '') ? _c('i', {
      staticClass: "material-icons note-icon"
    }, [_vm._v("note")]) : _vm._e()])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredResult.length == 0 || _vm.projectView == undefined),
      expression: "filteredResult.length == 0 || projectView == undefined"
    }],
    staticClass: "placeholder"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "float-left"
  }, [_c('i', {
    staticClass: "material-icons date-icon"
  }, [_vm._v("date_range")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder-image"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/image/invoice.png"),
      "alt": "projekt-ikon"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("Ingen opgaver for den"), _c('br'), _vm._v(" valgte dato eller montør")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6649a538","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/projekter.vue
// module id = 1010
// module chunks = 1